export default "__VITE_ASSET__Dkk8kFHF__"